<ng-container *ngIf="order$ | async as order">
  <sd-order-download-bill *ngIf="order.isB2BOrder" [order]="order" [large]="true"></sd-order-download-bill>
  <div class="actions">
    <a
      *ngIf="order.cancellable"
      [routerLink]="
        {
          cxRoute: 'orderCancel',
          params: order,
        } | cxUrl
      "
      class="btn btn-light btn-block"
    >
      Отменить товары
    </a>

    <a
      *ngIf="order.returnable"
      [routerLink]="
        {
          cxRoute: 'orderReturn',
          params: order,
        } | cxUrl
      "
      class="btn btn-block btn-light btn-block"
    >
      Запросить возврат
    </a>
  </div>
</ng-container>
